import React, { useRef, useState } from 'react';
import './element-delete.styles.scss';
import { useSelector } from 'react-redux';
import { ModalAlert, ModalConfirm } from '@/components/modal/modal.component';
import { UseCloudFunction } from '@/utils/firebase.utils';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';
import useAnalytics from '@/utils/useAnalytics';
import { properCase } from '@/utils/properCase';

const ElementDelete = ({
    element,
    onComplete,
    style,
    classText
}) => {

    const userProfile = useSelector(state => state.userData.userProfile);
    const membership = useSelector(state => state.userData.membership);
    const [ alertMessage, setAlertMessage ] = useState(null);
    const [ confirmMessage, setConfirmMessage ] = useState(null);
    const [ loading, setLoading ] = useState(false);
    const { trackEvent, trackException } = useAnalytics();
    const approveRef = useRef();
    
    function markAsInactive() {
        if (!element?.id) return;
        setConfirmMessage(`Are you sure you want to mark this ` + 
            `${
                element.type === 'prizepack' 
                ? 'Prize Pack' 
                : element.type === 'secretCode'
                ? 'Secret Code'
                : properCase(element.type)
            } as DELETED? This will remove it from your game. You can restore deleted game elements from the "Deleted" section.`);
        approveRef.current = () => {
            continueDelete();
        }

        async function continueDelete() { 
            setLoading(true);
            let tempData = {...element};
            tempData.status = 'inactive';
            const res = await UseCloudFunction(
                'saveGameElement', 
                {
                    'appId': userProfile.appId, 
                    'elementData': tempData, 
                    'userName': `${userProfile.fName} ${userProfile.lName}`,
                    'action': 'Deleted'
                }
            )
            console.log(res);
            if (res.error) {
                setAlertMessage('Something went wrong. Please try again later. Error: ' + res.error);
                setLoading(false);
                trackException(`Game Element Delete Error: ${res.error}`);
                return;
            }
            setAlertMessage('Game element deleted successfully.');
            setLoading(false);
            trackEvent(
                'game_element_deleted',
                'Game Manager',
                `${properCase(element.type)} deleted for game ${element.gameId}.`,
                null,
                membership
            );
            if (onComplete) {
                onComplete();
            }
        }
    }

    return (
        <div className={`element-delete ${classText ?? ''}`}>
            {
                (style === 'button') &&
                (
                    (loading)
                    ?
                    <button className='g-button small-btn'>
                        <ThreeDotsLoader />
                    </button>
                    :
                    <button 
                        type='button' 
                        className={`g-button small-btn red ${element.id ? '' : 'disabled'}`}
                        onClick={() => markAsInactive()}>
                        Delete
                    </button>
                )
            }
            {
                (style === 'menu-item') &&
                (
                    (loading)
                    ?
                    <div className='element-menu-item'>
                        <ThreeDotsLoader />
                    </div>
                    :
                    <div 
                        className={`element-menu-item ${element.id ? '' : 'disabled'}`}
                        onClick={() => markAsInactive()} >
                        <FontAwesomeIcon icon={faTrash} />
                        Delete
                    </div>
                )
            }
            <ModalConfirm
                show={confirmMessage}
                cancel={() => setConfirmMessage(null)}
                message={confirmMessage}
                onApprove={approveRef.current} />
            <ModalAlert
                show={alertMessage}
                cancel={() => setAlertMessage(null)}
                message={alertMessage} />
        </div>
    )
}

export default ElementDelete